import { createSlice } from "@reduxjs/toolkit";

const permissionSlice = createSlice({
    name: "permissions",
    initialState: {
        list: [],
    },

    reducers: {
        setPermissions: (state, action) => {
            state.list = action.payload;
        },
        clearPermissions: (state) => {
            state.list = [];
        },
    },
});

export const { setPermissions, clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
